import { render, staticRenderFns } from "./pop-vxe.vue?vue&type=template&id=50235004"
import script from "./pop-vxe.vue?vue&type=script&lang=js"
export * from "./pop-vxe.vue?vue&type=script&lang=js"
import style0 from "./pop-vxe.vue?vue&type=style&index=0&id=50235004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports